var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileConf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8458 6.6977L12.6519 2.50385C12.5685 2.42028 12.4694 2.35399 12.3603 2.30876C12.2512 2.26352 12.1342 2.24024 12.0161 2.24023H4.82666C4.42942 2.24023 4.04845 2.39804 3.76755 2.67893C3.48666 2.95982 3.32886 3.3408 3.32886 3.73804V16.9187C3.32886 17.3159 3.48666 17.6969 3.76755 17.9778C4.04845 18.2587 4.42942 18.4165 4.82666 18.4165H15.6108C16.0081 18.4165 16.3891 18.2587 16.6699 17.9778C16.9508 17.6969 17.1086 17.3159 17.1086 16.9187V7.33276C17.1086 7.09461 17.0141 6.86619 16.8458 6.6977ZM12.6152 5.01117L14.3377 6.73364H12.6152V5.01117ZM5.12622 16.6191V4.0376H10.8179V7.63232C10.8179 7.87067 10.9126 8.09925 11.0811 8.26779C11.2496 8.43632 11.4782 8.53101 11.7166 8.53101H15.3113V16.6191H5.12622Z",
    fill: "#1D2022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileConf);
export default __webpack_public_path__ + "static/media/file-conf.d10b2a62.svg";
export { ForwardRef as ReactComponent };